import React from "react";

const CartIcon: React.FC = () => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M5.07987 4L5.85063 13.2491C5.9802 14.804 7.28 16 8.84027 16H17.4384C18.8151 16 20.015 15.0631 20.3489 13.7276L21.9701 7.24254C22.1279 6.61139 21.6506 6 21 6H7.25347L6.99655 2.91695C6.95335 2.39866 6.52009 2 6 2H3C2.44772 2 2 2.44772 2 3C2 3.55228 2.44772 4 3 4H5.07987ZM7.42013 8H19.7192L18.4086 13.2425C18.2973 13.6877 17.8973 14 17.4384 14H8.84027C8.32018 14 7.88691 13.6013 7.84372 13.083L7.42013 8ZM8 22C9.10457 22 10 21.1046 10 20C10 18.8954 9.10457 18 8 18C6.89543 18 6 18.8954 6 20C6 21.1046 6.89543 22 8 22ZM18 20C18 21.1046 17.1046 22 16 22C14.8954 22 14 21.1046 14 20C14 18.8954 14.8954 18 16 18C17.1046 18 18 18.8954 18 20Z"
			fill="black"
		/>
	</svg>
);

export default CartIcon;
